import React from "react";
import {Grid} from "@material-ui/core";
import {OpenApiDefinitionWidget} from "@backstage/plugin-api-docs";
import {useEntity} from "@backstage/plugin-catalog-react";
import {SchemaEntity} from "../types";

const OpenAPIContent = () => {
  const {entity} = useEntity<SchemaEntity>();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <OpenApiDefinitionWidget definition={entity.spec.openApiDocs}/>
      </Grid>
    </Grid>
  );
};

export default OpenAPIContent;
